import { render, staticRenderFns } from "./productioninfo.vue?vue&type=template&id=611a8e10&scoped=true&"
import script from "./productioninfo.vue?vue&type=script&lang=js&"
export * from "./productioninfo.vue?vue&type=script&lang=js&"
import style0 from "./productioninfo.vue?vue&type=style&index=0&id=611a8e10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a8e10",
  null
  
)

export default component.exports